import { render, staticRenderFns } from "./JobListItemDetails.vue?vue&type=template&id=355f2401&functional=true"
import script from "./JobListItemDetails.vue?vue&type=script&lang=js"
export * from "./JobListItemDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports